import Courses from '@/containers/course/Home';
import View from '@/containers/course/View';
import Create from '@/containers/course/Create';
import CreateHome from '@/components/course/Create';
import DateSelector from '@/components/course/DateSelector';
import TimeSelector from '@/components/course/TimeSelector';
import Content from '@/components/course/Content';
import Created from '@/components/course/Created';

import {
    ROUTE_COURSE_HOME,
    ROUTE_COURSE_VIEW,
    ROUTE_COURSE_CREATE,
    ROUTE_COURSE_CREATE_DATE_SELECTOR,
    ROUTE_COURSE_CREATE_TIME_SELECTOR,
    ROUTE_COURSE_CREATE_CONTENT,
    ROUTE_COURSE_CREATE_CREATED,
} from './names';

export default [
    {
        path: '/courses',
        name: ROUTE_COURSE_HOME,
        component: Courses,
        meta: {
            trainer_auth: true,
            title: '课程安排',
        },
    },
    {
        path: '/course/:id(\\d+)',
        name: ROUTE_COURSE_VIEW,
        component: View,
        meta: {
            trainer_auth: true,
            title: '课程安排',
        },
    },
    {
        path: '/course/create',
        component: Create,
        children: [
            {
                path: '',
                name: ROUTE_COURSE_CREATE,
                component: CreateHome,
                meta: {
                    trainer_auth: true,
                    bridge: true,
                },
            },
            {
                path: 'date-selector',
                name: ROUTE_COURSE_CREATE_DATE_SELECTOR,
                component: DateSelector,
                meta: {
                    trainer_auth: true,
                    title: '申请新课程',
                },
            },
            {
                path: 'time-selector',
                name: ROUTE_COURSE_CREATE_TIME_SELECTOR,
                component: TimeSelector,
                meta: {
                    trainer_auth: true,
                    title: '申请新课程',
                },
            },
            {
                path: 'content',
                name: ROUTE_COURSE_CREATE_CONTENT,
                component: Content,
                meta: {
                    trainer_auth: true,
                    title: '申请新课程',
                },
            },
            {
                path: 'created/:id(\\d+)',
                name: ROUTE_COURSE_CREATE_CREATED,
                component: Created,
                meta: {
                    trainer_auth: true,
                    title: '申请新课程',
                },
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/router/course.js